import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import { RadioButtonGroup } from '@els/els-react--radio-button';
import GroupSubRadioButtons from './GroupSubRadioButtons';

export default function GroupRadioButton(props) {
  const { id, option, groupId, optionId, onRadioClick } = props;
  const title = option.get('title');
  const checked = option.get('checked');

  return (
    <>
      <RadioButtonGroup.Option
        className="group-radio-buttons-radio"
        checked={checked}
        onChange={() => {
          onRadioClick(id, groupId, optionId);
        }}
        label={title}
      />
      <GroupSubRadioButtons {...props} />
    </>
  );
}

GroupRadioButton.propTypes = {
  id: PropTypes.string.isRequired,
  option: PropTypes.instanceOf(Map),
  groupId: PropTypes.string.isRequired,
  optionId: PropTypes.string.isRequired,
  onRadioClick: PropTypes.func.isRequired,
};
